// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import ReadOutlined from '/app/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@ant-design/icons/es/icons/ReadOutlined';
import AppstoreOutlined from '/app/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@ant-design/icons/es/icons/AppstoreOutlined';
export default { ReadOutlined, AppstoreOutlined };
